mainApp.component('socketWebUi', {
	templateUrl: '/public/components/socket-web-ui.component.html',
	bindings: {
		site: '<'
	},
	controller: socketWebUiController
});

function socketWebUiController($scope, $state, SocketUIService, UserContextService) {
	let ctrl = this;
	ctrl.dropDownOpen = false;
	ctrl.sockets = null;
	ctrl.isEditor = UserContextService.isEditor();

	ctrl.$onChanges = function(changes){
		if (changes['site'] && ctrl.site) {
			ctrl.dropDownOpen = false;
			getSiteSockets(ctrl.site.id);
		}
	};

	ctrl.remoteSocketButtonPressed = function () {
			//if we have more than one socket - handle dropdown
			if (ctrl.sockets.length > 1) {
				ctrl.dropDownOpen = !ctrl.dropDownOpen;
			}
			//open socket UI for the one socket
			else {
				SocketUIService.openSocketUI(ctrl.sockets[0].id, $state.params.accountId);
			}
	};

	ctrl.openHaSocket = function(primary) {
		let socket = ctrl.sockets.filter(socket => socket.isPrimary === primary)[0];
		SocketUIService.openSocketUI(socket.id,$state.params.accountId)
	};

	function getSiteSockets(siteId) {
		store.fetch({
			method : 'GET',
			url : 'getSiteSockets',
			queryParams: {
				siteId: siteId
			},
			success: function(data) {
				ctrl.sockets = data.items;
			},
			error: function () {
				console.error("Failed getting sockets for site");
			}
		});
	}
}
